import {GenericErrorComponent} from "~/components/genericErrorComponent";
import {useIntellsysDevtoolsConfiguration} from "~/contexts/intellsysDevtoolsClientContext";

export function DefaultComponent() {
    const intellsysDevtoolsConfiguration = useIntellsysDevtoolsConfiguration();

    if (intellsysDevtoolsConfiguration.insaneLogs.tanstackRouterDebugging === true) {
        console.info(+new Date(), "tanstackRouterDebugging", "?", "component");
    }

    return <GenericErrorComponent error="404" />;
}
